import { css, CSSObject } from "styled-components";

export const Breakpoint = {
  Mobile: "mobile",
  Tablet: "tablet",
  Desktop: "desktop",
  DesktopWide: "desktopWide",
};

export const sizes = {
  [Breakpoint.Mobile]: 480,
  [Breakpoint.Tablet]: 768,
  [Breakpoint.Desktop]: 1024,
  [Breakpoint.DesktopWide]: 1280,
};

export const Media = Object.keys(sizes).reduce((acc: any, label: string) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  acc[label] = (literals: TemplateStringsArray, ...placeholders: any[]) => css`
    @media (max-width: ${sizes[label]}px) {
      ${css(literals, ...placeholders)}
    }
  `;
  return acc;
}, {});
